import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  CardBody,
  CardHeader,
  Row,
  Col,
  Badge,
  Spinner,
  Button   // ✅ Added this
} from "reactstrap";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "../Assets/css/style.css";
import AdminSidebar from "../Partials/adminsidebar";

const CandidateView = () => {

  const { id } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("admin_token");

  const handleExit = () => {
    localStorage.removeItem("admin_token");
    navigate("/admin-login");
  };

  const handleReturn = () => {
    navigate("/admin-candidates");
  };

  const fetchData = async () => {
    try {
      const res = await axios.get(
        // `http://localhost/qads_interview/admin/candidates_view.php?user_id=${id}`,
        `https://interview.qads.co.in/qads_interview/admin/candidates_view.php?user_id=${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setData(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner color="warning" />
      </Container>
    );
  }

  if (!data) return <div className="text-center mt-5">No Data Found</div>;

  return (

    <div style={{ display: "flex" }}>

  {/* Sidebar */}
  <AdminSidebar />

  {/* Main Content Area */}
  <div style={{
    marginLeft: "250px",
    width: "100%",
    padding: "20px"
  }}>

    <Container className="mt-4">

      {/* Candidate Info Card */}
      <Card className="mb-4 candidate-info-card">
        <CardBody>
          <Row className="align-items-center">

            <Col md="8">
              <h4 className="candidate-name">
                {data.candidate.name}
              </h4>
              <p>
                Domain:{" "}
                <Badge className="domain-badge">
                  {data.candidate.domain}
                </Badge>
              </p>
            </Col>

            <Col md="4" className="text-end">
              <Button
                className="return-btn me-2"
                onClick={handleReturn}
              >
                Return
              </Button>

              <Button
                className="exit-btn"
                onClick={handleExit}
              >
                Exit
              </Button>
            </Col>

          </Row>
        </CardBody>
      </Card>

      {/* Answers Section */}
      {data.answers.map((a) => (
        <Card key={a.question_id} className="mb-3 answer-card">
          <CardHeader className="question-header">
            {a.question}
          </CardHeader>

          <CardBody>
            <p><strong>Answer:</strong></p>

            <div className="answer-box">
              {a.answer}
            </div>

            <div className="mt-3">
              <strong>Marks Awarded:</strong>{" "}
              <Badge className="marks-badge">
                {a.marks_awarded ?? 0}
              </Badge>
            </div>

          </CardBody>
        </Card>
      ))}

    </Container>

  </div>

</div>
    
  );
};

export default CandidateView;